import { render, staticRenderFns } from "./UserMessageDetail.vue?vue&type=template&id=07637930&scoped=true&"
import script from "./UserMessageDetail.vue?vue&type=script&lang=js&"
export * from "./UserMessageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07637930",
  null
  
)

export default component.exports